import EnlilAxiosRestAPI from "../../../../util/EnlilAxiosRestAPI";
import {V1DocumentTypeIDOCToArray} from "../../../../util/Payload";

const getDocumentTypesByCategory = (baseQBE, categoryValue, idocResponse) => {
    const qbe = structuredClone(baseQBE);
    qbe.ShifamedMessage.DocumentType.QueryGroups.QueryGroup[0].Membership.Member = [
        {
            "Type": "Attribute",
            "Name": "Category",
            "Value": categoryValue,
            "Operator": "EQUAL"
        }
    ];

    return EnlilAxiosRestAPI({
        method: "GET",
        url: "t3/v1/document_types",
        json: true,
        params: {
            "QBE": btoa(JSON.stringify(qbe))
        },
        headers: {
            "idoc-response": idocResponse,
        },
    }).then((response) => V1DocumentTypeIDOCToArray(response.data) || {Results: []});
};

export const fetchMergedDocumentTypeCategories = (baseQBE, idocResponse, categoryValues = ["", "**NULL**"]) => {
    return getDocumentTypesByCategory(baseQBE, categoryValues[0], idocResponse)
        .then((firstResult) => {
            return getDocumentTypesByCategory(baseQBE, categoryValues[1], idocResponse)
                .then((secondResult) => {
                    const mergedResults = [
                        ...(firstResult.Results || []),
                        ...(secondResult.Results || []),
                    ];

                    return {
                        Results: mergedResults,
                        Count: mergedResults.length,
                    };
                });
        });
};
